import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '@/components/patterns/PageHeader.jsx';
import Tabs from '@/components/patterns/Tabs.jsx';
import AppearanceSection from './components/AppearanceSection.jsx';
import MembersSection from './components/MembersSection.jsx';
import OrganizationSection from './components/OrganizationSection.jsx';
import ProfileSection from './components/ProfileSection.jsx';
import './styles/settings.css';

const SECTIONS = [
  { value: 'profile', label: 'Profile', Panel: ProfileSection },
  { value: 'organization', label: 'Organization', Panel: OrganizationSection },
  { value: 'members', label: 'Members', Panel: MembersSection },
  { value: 'appearance', label: 'Appearance', Panel: AppearanceSection }
];

/** Settings: who you are, the organization you work in, who else is in it, and how Pieve looks. */
const SettingsScreen = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const current = SECTIONS.some((item) => item.value === section) ? section : 'profile';

  return (
    <div className="comp-page">
      <PageHeader title="Settings" description="Your profile, your organization and its members, and how Pieve looks on this device." />
      <Tabs label="Settings sections" value={current} onValueChange={(value) => navigate(`/settings/${value}`)} items={SECTIONS.map(({ value, label, Panel }) => ({ value, label, panel: value === current ? <Panel /> : null }))} />
    </div>
  );
};

export default SettingsScreen;
